import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BoxContainer } from "../layouts/Theme";
import { useFlow } from "../context/FlowContext";
import { useI18N } from "../context/I18NContext";
export default function Cancel(props) {
    const navigate = useNavigate();
    const theme = useTheme();
    const goTo = (e) => {
        let target = e.target.closest('button');
        if (!target) {
            target = e.target.closest('li');
        }
        let path = target.getAttribute('rel');
        navigate(`/${path}`);
    };
    const { t } = useI18N();
    const flow = useFlow();
    // this view is outside the flow, so there is no step to take a label from: it puts its own
    // title in the app bar
    const title = t('Afspraak annuleren');
    useEffect(() => {
        var _a;
        (_a = flow.setTitle) === null || _a === void 0 ? void 0 : _a.call(flow, title);
    }, [title]);
    return (_jsx(_Fragment, { children: _jsxs(BoxContainer, { children: [_jsx(Typography, { sx: { color: theme.palette.text.primary, my: 1 }, variant: "body1", children: t('Je staat op het punt om onderstaande afspraak te annuleren:') }), _jsx(Alert, { sx: { my: 1 }, severity: "info", variant: "filled", children: "Donderdag 22 mei, 19:30, Kick-boxen, Zaal 1" }), _jsx(Typography, { sx: { color: theme.palette.text.primary, my: 1 }, variant: "body1", children: t('Weet je zeker dat je je afspraak wil annuleren? Het is ook mogelijk om je afspraak te verzetten.') }), _jsx(Button, { onClick: goTo, rel: 'oa_widget_cancelled', fullWidth: true, sx: { my: 1 }, variant: "contained", children: t('Afspraak annuleren') }), _jsx(Button, { onClick: goTo, rel: 'oa_widget_reschedule', fullWidth: true, sx: { my: 1 }, variant: "contained", children: t('Afspraak verzetten') }), _jsx(Button, { onClick: goTo, rel: 'oa_widget_appointments', fullWidth: true, sx: { my: 1 }, variant: "outlined", children: t('Niet annuleren') })] }) }));
}
